import React, { useEffect, useState } from "react";
import { useSubscription } from "@apollo/client";
import useReactRouter from "use-react-router"
import { SUBSCRIPTION_ON_SELECT_STOCK_TO_LIVE } from "../../../graphql/live/subscription";

function ShowOnairLive() {
  const { match } = useReactRouter()
  const shopId = match.params.shopId;
  const liveId = match.params.liveId;

  const [stockData, setStockData] = useState()

  const { data, loading } = useSubscription(SUBSCRIPTION_ON_SELECT_STOCK_TO_LIVE, {
    variables: {
      shopId: shopId,
      liveId: liveId
    }
  });

  useEffect(() => {
    // console.log("data: ", data);
    if(data?.onSelectStockToLive){
      setStockData(data?.onSelectStockToLive)
    }
  }, [data])
  

  return (
    <div>
      <h1>Name: {stockData?.stock?.name ?? ""}</h1>
      <h1>Price: {stockData?.stock?.price ?? ""} {stockData?.stock?.currency ?? ""}</h1>
      <h1>CF Message: {stockData?.cfMessage ?? ""}</h1>
      <h1>Amount: {stockData?.amount ?? ""} {stockData?.amountAll ? `/ ${stockData?.amountAll}` : ""}</h1>
    </div>
  );
}

export default ShowOnairLive;